module.exports = __webpack_public_path__ + "static/media/successRadious.d635a64f.svg";